<template>
  <div id="contenedor-contratista-contratos">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'MainContratistasContratos',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
